import { openBlock as e, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M12.25 4a2.75 2.75 0 1 1 2.303 2.714l-.804 2.412A4.744 4.744 0 0 1 15.75 13c0 .976-.294 1.883-.799 2.637l1.384.692a.609.609 0 0 1 .022.011 3.75 3.75 0 1 1-.836 1.259l-1.642-.82a4.75 4.75 0 0 1-6.727-6.565L5.47 8.53a.752.752 0 0 1-.11-.14 2.75 2.75 0 1 1 1.03-1.03c.05.031.096.068.14.11l1.682 1.684A4.729 4.729 0 0 1 11 8.25c.484 0 .95.072 1.39.207l.797-2.39A2.744 2.744 0 0 1 12.25 4ZM15 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM2.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM11 9.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM16.75 19a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  c
];
function a(r, d) {
  return e(), l("svg", t, [...n]);
}
const i = { render: a };
export {
  i as default,
  a as render
};
